import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { shadows } from "../../../design-system/tokens/shadows";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/**
 * Figma "Modal header" (6433:560612). `position: relative` + `z-index` lift the
 * drop shadow over the body beneath it instead of letting the body paint over it.
 */
export const Header = styled.header`
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing[0.5]};
  width: 100%;
  padding: ${spacing[3]};
  background: ${rawColors.structural.white};
  border-radius: ${borderRadius.xl} ${borderRadius.xl} 0 0;
  box-shadow: ${shadows.component.createStoryModalHeader};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Title = styled.h3`
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
`;

/** Figma chip row (6433:560618 / 6433:560647) — shared with the card body. */
export const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;
